import React from 'react';
import { Avatar as AntdAvatar } from 'antd';

import './index.less';
import {
  DefaultAvatar,
  Robot01Avatar,
  Robot02Avatar,
  Robot03Avatar,
  Robot04Avatar,
  Robot05Avatar,
  Robot06Avatar,
  Robot07Avatar,
  Robot08Avatar,
  Robot09Avatar,
  Robot10Avatar,
  UserAvatar,
} from '../../../assets/avatars';

const SIZE_DEFAULT = 32;
const SHAPE_DEFAULT = 'square';
const MAIN_CLASS_NAME = 'avatar';

export type AvatarName =
  | 'default'
  | 'user'
  | 'robot-01'
  | 'robot-02'
  | 'robot-03'
  | 'robot-04'
  | 'robot-05'
  | 'robot-06'
  | 'robot-07'
  | 'robot-08'
  | 'robot-09'
  | 'robot-10';

export interface IAvatarProps {
  avatarName?: AvatarName;
  src?: React.ReactNode;
  icon?: React.ReactNode;
  className?: string;
  shape?: 'circle' | 'square';
  size?: number;
}

const Avatar: React.FC<IAvatarProps> = ({
  avatarName,
  icon,
  shape = SHAPE_DEFAULT,
  size = SIZE_DEFAULT,
  src,
  className,
  children,
}) => {
  const classes = [MAIN_CLASS_NAME, `${MAIN_CLASS_NAME}_${shape}`];
  className && classes.push(className);

  const renderSrc = () => {
    switch (avatarName) {
      case 'default':
        return <DefaultAvatar height={size} width={size} />;
      case 'user':
        return <UserAvatar height={size} width={size} />;
      case 'robot-01':
        return <img alt="robot-01" src={Robot01Avatar} />;
      case 'robot-02':
        return <img alt="robot-02" src={Robot02Avatar} />;
      case 'robot-03':
        return <img alt="robot-03" src={Robot03Avatar} />;
      case 'robot-04':
        return <img alt="robot-04" src={Robot04Avatar} />;
      case 'robot-05':
        return <img alt="robot-05" src={Robot05Avatar} />;
      case 'robot-06':
        return <img alt="robot-06" src={Robot06Avatar} />;
      case 'robot-07':
        return <img alt="robot-07" src={Robot07Avatar} />;
      case 'robot-08':
        return <img alt="robot-08" src={Robot08Avatar} />;
      case 'robot-09':
        return <img alt="robot-09" src={Robot09Avatar} />;
      case 'robot-10':
        return <img alt="robot-10" src={Robot10Avatar} />;
      default:
        return src;
    }
  };

  return (
    <AntdAvatar className={classes.join(' ')} draggable={false} icon={icon} shape={shape} size={size} src={renderSrc()}>
      {children}
    </AntdAvatar>
  );
};

export default Avatar;
